import { useEffect, useRef } from 'react';
import { di } from 'react-magnetic-di';
import type { FieldValues } from 'state/persisted/request-create';
import { useAdjustedFields } from '../../common/fake-uim/store';

export interface Props {
    fieldValues: FieldValues;
    setFieldValue(field: string, value: unknown, shouldValidate?: boolean): void;
}

export const UiModificationsFormValuesApplier = ({ fieldValues, setFieldValue }: Props) => {
    di(useAdjustedFields);

    const overrides = useAdjustedFields();
    const fieldValuesRef = useRef(fieldValues);

    // always refresh fieldValuesRef with the latest value
    fieldValuesRef.current = fieldValues;

    useEffect(() => {
        if (!overrides) {
            return;
        }

        for (const [fieldId, override] of Object.entries(overrides)) {
            const { value } = override;
            if (value !== fieldValuesRef.current[fieldId]) {
                setFieldValue(fieldId, value);
            }
        }
    }, [overrides, setFieldValue]);

    return null;
};
